<template>
  <main class="home">
    <HeaderM3 :logoLinkRoute="M3_Welcome" />
    <div class="main-body d-flex flex-row">
      <div class="w-100">
        <NavigationBar v-if="!isD2C" :current-step="currentStep" />
        <SaleTimeOut />
        <div>
          <div class="container p-0">
            <GoogleAnalyticsEcommerceTracker />
            <CustomerContactInfo />
          </div>
        </div>
      </div>
      <InConsoleSidebar />
    </div>

    <HelpMessage />
  </main>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import HeaderM3 from "@/apps/merchant3/components/HeaderM3.vue";
import CustomerContactInfo from "@/apps/merchant3/components/customer-registration/customer-contact-info/CustomerContactInfo.vue";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import NavigationBar from "@/apps/merchant3/shared-components/common/NavigationBar.vue";
import SaleTimeOut from "@/apps/merchant3/shared-components/common/SaleTimeout.vue";
import HelpMessage from "@/apps/merchant3/components/HelpMessage.vue";
import GoogleAnalyticsEcommerceTracker from "@/apps/merchant3/helpers/GoogleAnalyticsEcommerceTracker.vue";
import InConsoleSidebar from "@/apps/merchant3/components/in-console/ui/InConsoleSidebar.vue";
import { isDirectToCustomerSessionSet } from "@/apps/merchant3/helpers/navigationGuards";

const isD2C = computed(() => isDirectToCustomerSessionSet());
const M3_Welcome = ref(RouteName.M3Welcome);
const currentStep = ref(1);
</script>

<style scoped>
.main-body {
  background-color: white;
}

</style>
